import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IRelatedProductsOptions } from '@df/catalog-ui/related-products/related-products.service';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsOutletBlockComponent } from '../../catalog/outlet-block/icms-outlet-block.component';
import { BasketRelatedProductsComponent } from '../related-products/basket-related-products.component';
import { BasketAddNoticeInitiatorService } from './basket-add-notice-initiator.service';
import { BasketAddNoticeItemComponent } from './basket-add-notice-item.component';
import { BasketAddNotice } from './basket-add-notice.namespace';
@DfCmsModal({
    id: BasketAddNotice.basketAddNoticeModalId,
    name: 'Basket Add Notice Popup',
    position: 'bottom',
    cmsNonOpenable: 'Modal can only be opened in a real case scenario',
    config: () => ({
        width: '100%',
        maxWidth: '100vw',
        modalClass: 'p-a-0',
        position: { bottom: '0' },
        closeOnNavigation: true
    }),
    initiators: [BasketAddNoticeInitiatorService],
    reopenPolicy: NDfModal.ReopenPolicy.passData,
    sizeRestriction: ['S', 'M'],
    forbiddenLocation: /^\/(basket|checkout)$/
})
@ICmsComponent<BasketAddNoticeComponent>({
    name: 'Basket Add Notice Popup',
    id: BasketAddNotice.basketAddNoticeModalId,
    block: {
        url: BasketAddNotice.basketAddNoticeModalId
    },
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IField>{
            key: 'klevu_recommendations_id',
            type: NICmsContentField.EFieldType.text,
            title: 'Klevu Recommendations ID'
        }
    ]
})
@Component({
    selector: 'basket-add-notice',
    templateUrl: './basket-add-notice.html',
    standalone: true,
    imports: [BasketAddNoticeItemComponent, TranslationModule, BasketRelatedProductsComponent, ICmsOutletBlockComponent, RouterLink],
    styleUrls: ['./basket-add-notice.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketAddNoticeComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content: BasketAddNotice.IBlockContent;
    addedItem: BasketItem;
    addedItemsQty: number;
    addedGiftItem: BasketItem;

    constructor(
        @Optional() private modalRef: ModalRef<BasketAddNotice.IBlockContent>,
        @Optional() @Inject(MODAL_DATA) basketAddNoticeData: BasketAddNotice.IModalData,
        readonly basket: Basket
    ) {
        super();
        if (basketAddNoticeData) {
            this.onDateUpdate(basketAddNoticeData);
        }
    }

    ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.basket.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    updateModalData(data: BasketAddNotice.IModalData) {
        this.onDateUpdate(data);
        this.changeDetectorRef.detectChanges();
    }

    protected onDateUpdate(basketAddNoticeData: BasketAddNotice.IModalData): void {
        if (basketAddNoticeData.basketItem) {
            this.addedItem = basketAddNoticeData.basketItem;
            this.addedItemsQty = basketAddNoticeData.addedItemsQty;
            this.addedGiftItem = basketAddNoticeData.giftItem;
        }
    }

    close(): void {
        this.modalRef?.close();
    }

    get relatedProductsOptions(): IRelatedProductsOptions {
        return {
            engines: [
                { id: KlevuSearch.contextRecommendationsBasketEngineId, options: { strategyId: this.content.klevu_recommendations_id } }
            ]
        };
    }
}
